export const PrintContent = (divId: string, title: string): boolean => {
  const contents = document.getElementById(divId)?.innerHTML;
  const frame1: any = document.createElement('iframe');
  frame1.name = 'frame1';
  frame1.style.position = 'absolute';
  frame1.style.top = '-1000000px';
  document.body.appendChild(frame1);
  const frameDoc =
    frame1.contentWindow != null
      ? frame1.contentWindow
      : frame1.contentDocument.document != null
      ? frame1.contentDocument.document
      : frame1.contentDocument;
  frameDoc.document.open();
  frameDoc.document.write(`<html><head><title>${title}</title>`);
  frameDoc.document.write('</head><body>');
  // frameDoc.document.write(
  //   '</head><style>@media print{body {color : #eee !important;font-size : 1em;border:1px solid #000; padding:77px;}}</style><body>'
  // );
  frameDoc.document.write(`<div class="print-div">${contents != null ? contents : ''}</div?`);
  frameDoc.document.write('</body></html>');
  frameDoc.document.close();
  setTimeout(function () {
    window.frames['frame1' as any].focus();
    window.frames['frame1' as any].print();
    document.body.removeChild(frame1);
  }, 500);
  return false;
};

// PrintContent('print-container', 'Page Title');
